// extracted by mini-css-extract-plugin
module.exports = {"landingfaqContainer":"faqPage_landingfaqContainer__3RMzt","landingfaqBody":"faqPage_landingfaqBody__nQ_1k"};